import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/**
 * Created by tonicli on 2017/3/21.
 */
var state = {
  IDLE: 0,
  PENDING: 1
};
export default function () {
  var _queue = [];
  var _state = state.IDLE;
  function _onCompleted(state, res) {
    var queue = _queue,
      item;
    _state = state.IDLE;
    if (!queue.length) {
      return res;
    }
    while (item = queue.shift()) {
      item[state](JSON.parse(JSON.stringify(res)));
    }
    return res;
  }
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      var _this = this;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_state === state.PENDING)) {
                _context.next = 4;
                break;
              }
              _context.next = 3;
              return new Promise(function (resolve, _reject) {
                _queue.push({
                  resolve: function resolve(response) {
                    setTimeout(function () {
                      _this.response = response;
                    }, 0);
                  },
                  reject: function reject(err) {
                    setTimeout(function () {
                      _reject(err);
                    }, 0);
                  }
                });
              });
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
              _state = state.PENDING;
              _context.prev = 5;
              _context.next = 8;
              return next();
            case 8:
              _onCompleted('resolve', this.response);
              _context.next = 15;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](5);
              _onCompleted('reject', _context.t0);
              throw _context.t0;
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 11]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}